import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Input, Row, Table, Tag } from "antd";
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { searchLength, trangThaiDonNghiPhep } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon } from '../../helpers/common';
import { TimKiemDonNghiPhepPagingResponse } from '../../models/donnghiphep/DonNghiPhep';
import { timKiemDonNghiPhepCaNhan } from '../../services/donnghiphep';
import dayjs, { Dayjs } from 'dayjs';

const DanhSachDangKyPhep = () => {
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const menu: any = menuHelper.checkMultiPermission([Links.Phep.ChiTiet, Links.Phep.Xem]);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [nam, setNam] = useState<string>(new Date().getFullYear().toString());
    const [namValue, setNamValue] = useState<Dayjs | null>(dayjs());
    const namFormat: DatePickerProps['format'] = (value) => `Năm ${value.format('YYYY')}`;

    const [page, setPage] = useState(1);
    const [danhSach, setDanhSach] = useState<TimKiemDonNghiPhepPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });

    const timkiem = async (tuKhoa: string, nam: string, start: number, length: number, page: number) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            const temp = await timKiemDonNghiPhepCaNhan(tuKhoa,nam, start, length);
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });
            setIsLoadingTable(false);
        }
        catch (error: any) {
            toast.error(error);
            setIsLoadingTable(false);
        };
    }

    const onChange: DatePickerProps['onChange'] = (year) => {
        var yearStr = year?.format('YYYY');
        setNamValue(year);
        if (yearStr) {
            setNam(yearStr);
            timkiem(tuKhoa, yearStr, 0, 0, 0);
        } else {
            setNam("");
            timkiem(tuKhoa, "", 0, 0, 0);
        }
    }


    useEffect(() => {
        if (reloadPage) {
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
            timkiem(tuKhoa,nam, 0, 0, 0);
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(tuKhoa, nam, 0, 0, 0)
        }
    };
    return (
        <section>
            <ContentHeader title="Danh sách đơn nghỉ phép cá nhân" />
            <Row gutter={8} className="form-group">
                <Col span={4}>
                    <DatePicker changeOnBlur={true} value={namValue} style={{ width: "100%" }} placeholder="Năm" picker="year" format={namFormat} onChange={onChange} />
                </Col>
                <Col span={8}>
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên nhân viên, tên phòng ban, loại nghỉ phép" onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Col span={4}>
                    <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(tuKhoa,nam, 0, 0, 0)}>
                        Tìm kiếm
                    </Button>
                </Col>
                <Col span={8}>
                    {
                        menu[Links.Phep.ChiTiet] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.Phep.ChiTiet}><PlusOutlined rev="" />Thêm mới</Link>
                    }
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={danhSach.data || []}
                            loading={isLoadingTable}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            pagination={{
                                current: page,
                                onChange: (page, pageSize) => {
                                    setPage(page);
                                },
                            }}
                        >
                            <Column title="STT" key="STT" width="5%" render={(value, record, index) =>
                                (<span key={"stt" + index}> {(page - 1) * searchLength + index + 1}</span>)
                            } />
                            <Column title="Nhân viên" width="25%" dataIndex="tenNhanVien" key="tenNhanVien" />
                            <Column title="Loại nghỉ" width="15%" dataIndex="tenLoaiNghiPhep" key="loaiNghiPhep" />
                            <Column title="Từ ngày" width="15%" dataIndex="tuNgay" key="tuNgay" render={(value, record) =>
                                (<span>{dateCommon.formatDate(value)}</span>)
                            } />
                            <Column title="Đến ngày" width="15%" dataIndex="denNgay" key="denNgay" render={(value, record) =>
                                (<span>{dateCommon.formatDate(value)}</span>)
                            } />
                            <Column title="Trạng thái" width="15%" dataIndex="trangThai" key="trangThai" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case trangThaiDonNghiPhep.khoiTao: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
                                    case trangThaiDonNghiPhep.trinh: tag = (<Tag color="warning">Trình Lãnh đạo</Tag>); break;
                                    case trangThaiDonNghiPhep.daDuyet: tag = (<Tag color="success">Đã Duyệt</Tag>); break;
                                    case trangThaiDonNghiPhep.tuChoi: tag = (<Tag color="error">Từ chối</Tag>); break;
                                    case trangThaiDonNghiPhep.yKien: tag = (<Tag color="orange">Lấy ý kiến</Tag>); break;
                                    case trangThaiDonNghiPhep.yeuCauHuy: tag = (<Tag color="cyan">Yêu cầu hủy</Tag>); break;
                                    case trangThaiDonNghiPhep.daHuy: tag = (<Tag color="error">Đã hủy</Tag>); break;
                                }
                                return tag;
                            }} />
                            <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                return menu[Links.Phep.Xem]
                                    ? (<Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.Phep.Xem + "?id=" + record.id}>Xem</Link>)
                                    : "";
                            }} />
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachDangKyPhep;